import React from "react";
//import logo from "./logo.svg";
import "./App.css";
import "./Style.css";
import Timeline from "./Timeline/Timeline";
import TimelineIndex from "./Timeline/TimelineIndex";
import TimelineIndexPeriod from "./Timeline/TimelineIndexPeriod";
import TimelineIndexPreview from "./Timeline/TimelineIndexPreview";
import Routes from "./Timeline/Routes";
import EventSlider from "./Timeline/EventSlider";
import EventSlider2 from "./Timeline/EventSlider2";
import EventSliderIndex from "./Timeline/EventSliderIndex";
import EventSliderIndexPeriod from "./Timeline/EventSliderIndexPeriod";
import TimelineIndexPreviewPeriod from "./Timeline/TimelineIndexPreviewPeriod";
import PeriodEvent from "./Timeline/PeriodEvent";
import PeriodEventPeriod from "./Timeline/PeriodEventPeriod";
import PeriodEventSlider from "./Timeline/PeriodEventSlider";
import { BrowserRouter, Switch, Link } from "react-router-dom";
import { Route, IndexRoute } from "react-router";
import axios from "axios";
const { apiUrl } = require('./Timeline/config')
const { apiEndpointUrl } = require('./Timeline/configAPI')

const Routers = props => {
  // console.log("proppps", props);
  // console.log("propppsxxxxx", props);
  return (
    <div>
      <Switch>
        {/* <Route path="/" component={Timeline} exact={true} /> */}
        <Route path="/epa_timeline/preview" component={Timeline} exact={true} /> 
        {/* localhost */}
        <Route path="/epa_timeline" component={TimelineIndexPeriod} exact={true} />
        <Route path="/epa_timeline/event/:id" component={EventSlider} exact={true} />
        <Route path="/epa_timeline/eventIndex/:id" component={EventSliderIndexPeriod} exact={true} />
        <Route path="/epa_timeline/event2" component={EventSlider2} exact={true} />
        <Route path="/epa_timeline/periodEvent/:id" component={PeriodEventPeriod} exact={true} />
        <Route path="/epa_timeline/eventSlider/:periodId/:eventId" component={PeriodEventSlider} exact={true} />
      </Switch>
    </div>
  );
};

function loadData(url) {
  axios.get(url)
  .then(function (response) {
    // console.log("loadData", url + " -> " + response.ok);
    return response.body;
  })
  // .then(function (data) {
  //   console.log("data: ", data);
  //   this.setState({ content: data });
  // }.bind(this))
  // .catch(function (err) {
  //   console.log("failed to load ", url, err.stack);
  // });
}

function App() {
  // loadData(apiEndpointUrl + "/api/timeline")
  // console.log("appsssssssss")
  return (
    <div>
      {/* <BrowserRouter basename="/"> */}
      <BrowserRouter>
        <div>
          <Routers />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
